'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _taxonomyNodePropType = require('../PropTypes/taxonomyNodePropType');

var _taxonomyNodePropType2 = _interopRequireDefault(_taxonomyNodePropType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RenderCity = function RenderCity(_ref) {
  var node = _ref.node;
  return _react2.default.createElement(
    'div',
    {
      className: 'quiver-taxonomy-navigator__render-city'
    },
    node.name
  );
};

RenderCity.propTypes = {
  node: _taxonomyNodePropType2.default
};

exports.default = RenderCity;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/TaxonomyNavigator/RenderCity.js
// module id = 681
// module chunks = 11